<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="80px">
				<el-col :span="4">
						<el-form-item label="月份">
							<el-date-picker   v-model="searchParams.month" type="month" placeholder="选择月">
							</el-date-picker>
						</el-form-item>
					</el-col>
				<el-col :span="4">
						<el-form-item label="类型">
							<el-select v-model="searchParams.type" placeholder="请选择">
								<el-option v-for="item in ['线上课','刷题']" :key="item" :label="item"
									:value="item">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				<el-row>
					<el-col :span="4">
						<el-form-item label="班级名称">
							<el-input v-model="searchParams.name"></el-input>
						</el-form-item>
					</el-col>
					<div class="search-btn">
						<el-button type="primary" icon="el-icon-search" @click="list">搜索</el-button>
						<el-button @click="clearSearchVal">清空</el-button>
					</div>
				</el-row>
			</el-form>
		</div>
            <div class="dataTable autoFlex" v-if="listData">
			<el-table class="table" :data="listData.records" stripe border height="auto" @selection-change="selectionChange" v-loading="listLoading">
						<el-table-column type="selection" width="55" fixed="left"></el-table-column>
						<el-table-column prop="updateTime" label="创建时间"></el-table-column>
						<el-table-column prop="name" label="班级名称"></el-table-column>
						<el-table-column prop="name" label="课程"></el-table-column>
						<el-table-column prop="name" label="人数"></el-table-column>
						<el-table-column prop="name" label="最后进班"></el-table-column>
				<el-table-column label="操作" fixed="right" width="200px">
					<template slot-scope="scope">
						<div class="dataTable-operator">
							<el-button   size="mini" icon="el-icon-search" type="primary" @click="remove(scope.$index, scope.row)">进度</el-button>
	                                    <el-button   size="mini" icon="el-icon-delete" type="danger" @click="remove(scope.$index, scope.row)">删除</el-button>
                        </div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pageBar">
				<el-pagination 
				@size-change="sizeChange" 
				@current-change="currentChange" 
				:total="listData.total" 
				:page-size="page.size"
				:current-page="page.current" 
				:layout="this.$constant.page.layout" 
				:page-sizes="this.$constant.page.pageSizes"></el-pagination>
			</div>
		</div>
		<edit ref="edit"></edit>
	</div>
</template>
<script>
import edit from './edit.vue';
import api from '@/api/online/clazz/clazz.js';
export default {
	name: 'tDepartment',
	components: {
		edit
	},
	data() {
		return {
			searchParams: {},
			isShowMoreSearch: false,
			listLoading: false,
			listData: [],
			selected: [],
			page: new this.$constant.pageObj(),
		};
	},
	methods: {
		//获取数据
		list() {
			this.listLoading = true;
			let params = this.$utils.merger(this.searchParams, this.page);
			api.list(params, response => {
				this.listData = response.data;
				this.listLoading = false;
			})
		},
 
		//改变选择项
		selectionChange(val) {
			//清空
			this.selected = [];
			for (let item of val) {
				this.selected.push(item.id);
			}
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},
		//清空搜索框
		clearSearchVal() {
			this.searchParams = {};
		}
	},
	mounted() {
		this.list();
	}
};
</script>

<style lang="scss" scoped="scoped">
	@import '~common/custom/css/common.scss';
</style>

